/* @flow */
import React, {
  useState,
} from 'react';
import { useSelector } from 'react-redux';
import dayjs from 'dayjs';
import { times } from 'lodash/fp';

import {
  dataPerDaySelector,
} from '../modules/todo/selectors';


const DayPagingContext = React.createContext<Object>({
  days: [],
  selectedDate: new Date(),
  setSelectedDate: () => {},
});

export const DayPagingProvider = ({ children }: Object) => {
  const tomorrow = dayjs().add(1, 'day').startOf('day'),
        [weekIndex, setWeekIndex] = useState(0),
        [selectedDate, setSelectedDate] = useState(tomorrow),
        thisWeek = dayjs().startOf('week'),
        days = times((index) => thisWeek.add(index, 'days'), 7 * (weekIndex + 3)),
        endOfWeek = selectedDate.add(weekIndex + 1, 'week').endOf('week');

  const dataPerDay = useSelector((state) => dataPerDaySelector(state, {
    from: dayjs().startOf('minute').toDate(),
    until: endOfWeek.toDate(),
  }));

  return (
    <DayPagingContext.Provider value={{
      setSelectedDate, selectedDate, days, weekIndex, setWeekIndex, dataPerDay,
    }}
    >
      { children }
    </DayPagingContext.Provider>
  );
};

export default DayPagingContext;
